import React from 'react'
import { Image } from 'semantic-ui-react'

function SingleImage({ src }) {
  return (
    <Image src={src} />
  )
}

export default SingleImage



// WEBPACK FOOTER //
// ./src/views/components/SingleImage.js